import React from "react";
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonType
} from "../../../../Shared/Buttons/React";
import { useTranslationContext } from "../../context";

interface ProvetContactDetailsSubmitProps {
  /** Handler for form submission */
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Submit button component for the contact details form.
 *
 * Simple presentational component that renders the "To Summary" button
 * with proper styling and translation.
 *
 * @param onSubmit - Click handler for form submission
 *
 * @example
 * ```tsx
 * <ProvetContactDetailsSubmit
 *   onSubmit={(e) => {
 *     e.preventDefault();
 *     validateAndSubmitForm();
 *   }}
 * />
 * ```
 */
export const ProvetContactDetailsSubmit = ({
  onSubmit
}: ProvetContactDetailsSubmitProps) => {
  const translationContext = useTranslationContext();

  return (
    <Button
      additionalClass="self-start"
      onClick={onSubmit}
      type={ButtonType.Button}
      size={ButtonSize.LG}
      color={ButtonColor.Turquoise}
      data-online-booking-action="confirm"
    >
      {translationContext?.translations?.toSummary}
    </Button>
  );
};

export default ProvetContactDetailsSubmit;
